// Load Google reCAPTCHA API using a standard script tag
(function () {
    var script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
})();

let failed_attempts = parseInt(localStorage.getItem("login_failed_attempts") || "0");
let captcha_loaded = false;

function show_captcha() {
    console.log("login_recaptcha: show_captcha() called. captcha_loaded =", captcha_loaded);
    if (captcha_loaded) return;
    
    // Create container if it doesn't exist
    if ($("#login-captcha-container").length === 0) {
        console.log("login_recaptcha: Creating #login-captcha-container");
        $(".form-login").find(".page-card-actions").before(
            '<div id="login-captcha-container" style="margin-bottom: 15px; display: flex; justify-content: center;"></div>'
        );
    }

    $("#login-captcha-container").show();
    console.log("login_recaptcha: Container shown. Waiting for grecaptcha...");

    // Wait for grecaptcha to be available
    var interval = setInterval(function () {
        if (typeof grecaptcha !== "undefined" && typeof grecaptcha.render !== "undefined") {
            clearInterval(interval);
            console.log("login_recaptcha: grecaptcha is ready! Rendering widget...");
            try {
                grecaptcha.render("login-captcha-container", {
                    sitekey: "6Ld5PbEtAAAAAHWxCC4C93ZKMKe3D9wyp4O9Jm8o"
                });
                captcha_loaded = true;
                console.log("login_recaptcha: Widget rendered successfully!");
            } catch (e) {
                console.error("login_recaptcha: Error rendering widget:", e);
            }
        }
    }, 200);
}

// Render immediately on page load
$(document).ready(function() {
    console.log("login_recaptcha: document.ready. Always showing CAPTCHA.");
    show_captcha();
    
    // Intercept Frappe's AJAX requests to include the reCAPTCHA token
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        if (options.type && options.type.toUpperCase() === "POST") {
            var token = $("#g-recaptcha-response").val();
            if (token) {
                if (typeof options.data === "string") {
                    options.data += "&g-recaptcha-response=" + encodeURIComponent(token);
                } else if (options.data instanceof FormData) {
                    options.data.append("g-recaptcha-response", token);
                } else if (typeof options.data === "object") {
                    options.data["g-recaptcha-response"] = token;
                }
            }
        }
    });
});
